import React, { Fragment, useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Spinner, Form } from 'react-bootstrap'

import Card from "react-bootstrap/Card";
import Nav from "react-bootstrap/Nav";
import Button from "react-bootstrap/Button";
import { Link, Route, NavLink } from "react-router-dom";
import { FormGroup, Input, Label, ModalBody, ModalFooter } from "reactstrap";
import Modal from "react-bootstrap/Modal";


const ReportItem = ({ labels, data, Save, name, onHide }) => {
    const [fields, setFields] = useState(labels);
    const [values, setValues] = useState(data);
    const [Change, AllowChange] = useState(true)
    useEffect(() => {
        setValues(data)
    }, [data]);

    return (<>
        <ModalBody>
            <div className={"col-12 p-0"}>
                <Card.Body>
                    {values && fields && Object.keys(fields).length > 0 && <Form>
                        {Object.keys(fields).map(item => (values[item] != null &&
                            <Form.Group key={item} controlId={item}>
                                <Form.Label>{fields[item]}</Form.Label>
                                <Form.Control type="number" lang='nl' readOnly={!Change} value={values[item] ?
                                    Number(values[item]) : 0}
                                    onChange={e => e.target.value ? setValues({
                                        ...values,
                                        [item]: e.target.value
                                    }) : setValues({ ...values, [item]: '0' })} />
                            </Form.Group>)
                        )}
                    </Form>
                    }
                </Card.Body>
            </div>
        </ModalBody>
        <ModalFooter>
            <div className="left-side">
                <Button className="btn-link" variant="wskazniki" type="button" onClick={e => { Save(values, name); AllowChange(!Change); onHide(false) }}>Zapisz</Button>
            </div>
            <div className="divider" />
            <div className="right-side">
                <Button className="btn-link" variant="danger" type="button" onClick={e => onHide(false)}>Anuluj</Button>
            </div>
        </ModalFooter>
    </>)
};
const style = {
    borderLeft: '1px solid rgba(0,0,0,.125)',
    borderRight: '0px',
    borderBottom: '0px',
}
export default ReportItem